import React from 'react';
import { Icon } from '@iconify/react';
import { LoyaltyActiveSystem } from '@/types/loyalty';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  currentSystem: LoyaltyActiveSystem;
  targetSystem: LoyaltyActiveSystem;
}

export const SwitchSystemConfirmModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
  currentSystem,
  targetSystem,
}) => {
  if (!isOpen) return null;

  const systemNames: Record<LoyaltyActiveSystem, string> = {
    points: 'Sistem poin',
    membership: 'Membership',
    stamp: 'Booking gratis',
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-[rgba(14,23,38,0.5)]">
      <div className="w-full max-w-[420px] rounded-[16px] bg-white border border-[#E0E6ED] shadow-[0_4px_12px_rgba(14,23,38,.12)] p-6 space-y-4 text-center">
        <Icon icon="ph:warning-octagon" className="w-10 h-10 text-[#FC480D] mx-auto" />

        <div>
          <h2 className="text-[18px] font-bold text-[#0E1726]">Ganti Sistem Loyalty Aktif?</h2>
          <p className="text-[14px] text-[#8C8C8C] mt-1.5 leading-[20px]">
            Anda akan beralih dari <b className="text-[#0E1726]">{systemNames[currentSystem]}</b> ke{' '}
            <b className="text-[#FC480D]">{systemNames[targetSystem]}</b>.
          </p>
        </div>

        <div className="rounded-[12px] bg-[#F6F6F6] border border-[#E0E6ED] p-3.5 text-left text-[13px] text-[#1F1F1F] space-y-2 leading-[18px]">
          <div className="flex items-start gap-2">
            <Icon icon="ph:info" className="w-4 h-4 shrink-0 text-[#8C8C8C] mt-0.5" />
            <span>
              <b>Progress sistem lama dibekukan</b> (tidak dihapus). Pelanggan tidak lagi mendapat poin/stamp baru, namun data lama tetap tersimpan.
            </span>
          </div>
          <div className="flex items-start gap-2">
            <Icon icon="ph:sparkle" className="w-4 h-4 shrink-0 text-[#8C8C8C] mt-0.5" />
            <span>
              <b>Sistem baru dimulai dari nol</b> untuk seluruh pelanggan arena Anda.
            </span>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-2 border-t border-[#E0E6ED]">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 h-10 px-[18px] rounded-full bg-[#FFF5EE] hover:bg-[#ffe8db] text-[#FC480D] text-[14px] font-semibold transition-colors"
          >
            Batalkan
          </button>
          <button
            type="button"
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="flex-1 h-10 px-[18px] rounded-full bg-[#FC480D] hover:bg-[#E8490F] text-white text-[14px] font-semibold transition-colors"
          >
            Ya, Ganti Sistem
          </button>
        </div>
      </div>
    </div>
  );
};

export default SwitchSystemConfirmModal;
